<template>
  <div class="video flex justify-center">
    <video
      v-if="!career"
      :muted="muted"
      @click="muted = !muted"
      class="max-w"
      autoplay
      playsinline
      poster="/img/poster.jpg"
    >
      <source src="/milsped_movie.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <video
      v-if="career"
      :muted="muted"
      @click="muted = !muted"
      class="max-w"
      autoplay
      playsinline
      poster="/img/quote.webp"
    >
      <source src="/milsped_career.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  props: {
    career: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      muted: true
    }
  },
  methods: {
    toggleMute() {
      // eslint-disable-next-line no-console
      console.log('mute')
    }
  }
}
</script>

<style scoped>
video {
  height: auto;
  width: 100%;
  max-height: 450px;
}
div {
  height: 350px;
}
</style>
